<header class="sidebar-header">
    <mat-toolbar>
        <h2 tabindex="-1" cdkFocusInitial>How can we help you?</h2>
        <button class="close-button" type="button" mat-icon-button (click)="onClick_toggleHelp()" aria-label="close help" matTooltip="Close help">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
</header>

<form role="form" (submit)="onSubmit_searchArticles($event)" (reset)="onReset_clearSearch()" aria-labelledby="aria_help_search">
    <mat-form-field appearance="standard">
        <mat-label id="aria_help_search">Search help articles</mat-label>
        <input matInput name="search" [(ngModel)]="searchString" (input)="onSearchInput(searchString)">
        <mat-icon matPrefix svgIcon="search" class="teller-online-icon"></mat-icon>
        <button mat-icon-button matSuffix type="reset" *ngIf="searchString" matTooltip="Clear Search">
            <mat-icon matSuffix>close</mat-icon>
        </button>
    </mat-form-field>
</form>

<mat-list aria-labelledby="aria_relevant_articles" role="list" *ngIf="relevantArticles?.length > 0">
    <h3 mat-subheader id="aria_relevant_articles">Relevant Articles</h3>
    <ng-container *ngFor="let section of relevantGroups">
        <h4 mat-subheader class="group-subheader" *ngIf="section.group">{{section.group}}</h4>
        <mat-list-item *ngFor="let article of section.articles">
            <h4 mat-line *ngIf="!section.group">{{article.title}}</h4>
            <h5 mat-line *ngIf="section.group">{{article.title}}</h5>
            <div mat-line [innerHtml]="article.trustedBody"></div>
        </mat-list-item>
    </ng-container>
</mat-list>

<mat-list aria-labelledby="aria_other_articles" role="list">
    <h3 mat-subheader id="aria_other_articles"><ng-template [ngIf]="relevantArticles?.length > 0">Other </ng-template>Articles</h3>
    <mat-list-item *ngFor="let article of otherArticles">
        <h4 mat-line>{{article.title}}</h4>
        <div mat-line [innerHtml]="article.trustedBody"></div>
    </mat-list-item>
</mat-list>
<a [routerLink]="viewAllRoute" class="view-all" *ngIf="showViewAllLink && totalArticleCount > relevantArticles?.length + otherArticles?.length && appService.currentUrl != 'help'" mat-button color="accent">View All Articles</a>
